import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import closeIcon from '../../assets/images/close.svg';

interface IFilterMobileProps {
  title: string;
  toogleFilter(): void;
  FilterOptions: JSX.Element;
}

const FilterMobile = ({
  title,
  toogleFilter,
  FilterOptions,
}: IFilterMobileProps) => {
  return (
    <aside
      className='search_table__content__table__filter'
      onClick={toogleFilter}
    >
      <div
        className='search_table__content__table__filter__content'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='search_table__content__table__filter__content__header'>
          <Text size={14} className='text--grey-200 text--weight-600'>
            {title}
          </Text>
          <Image size='m' src={closeIcon} onClick={toogleFilter} />
        </div>
        <div className='search_table__content__table__filter__content__body'>
          {FilterOptions}
        </div>
      </div>
    </aside>
  );
};

export default FilterMobile;
